/*22ccfc5424b64920a681c2b721ce04e6*/

import * as React from "react"
import Layout from "../../../components/layout.js"
import { SEO } from "../../../components/organisms/seo.js"
import { useState } from "react"
import LoadingOverlay from "react-loading-overlay-cf"

// const ClientSideOnlyLazy = React.lazy(() =>
//   import("@stoplight/elements").then(module => ({ default: module.API }))
// )

import { API } from "@stoplight/elements"
import "@stoplight/elements/styles.min.css"

const DeveloperPortalPage = ({ data, location }) => {
  const [loadingMessage] = useState(null)
  const [loading] = useState(false)

  const isSSR = typeof window === "undefined"

  return (
    <Layout pathname={location.pathname}>
      <LoadingOverlay active={loading} spinner text={loadingMessage}>
        <div className="bg-gray-50 dark:bg-gray-900 antialised">
          <header></header>

          <div className="max-w-screen-2xl mx-auto flex w-full h-full relative pt-4 xl:pt-8 px-4">
            {/* <div>
              <DeveloperPortalSideMenu />
            </div> */}

            <main className="flex-1 pb-4 h-full overflow-y-auto lg:pl-4">
              {!isSSR && (
                <React.Suspense fallback={<div />}>
                  <API
                    apiDescriptionUrl="https://myradar.com/openapi-joined.json"
                    router={
                      typeof window === "undefined" ? "memory" : "history"
                    }
                    basePath="/developer_portal/api_docs"
                  />
                </React.Suspense>
              )}
            </main>
          </div>
        </div>
      </LoadingOverlay>
    </Layout>
  )
}
export default DeveloperPortalPage

// eslint-disable-next-line react/jsx-pascal-case
export const Head = () => (
  <SEO
    title="Developer Portal | Powered by MyRadar"
    seo_image="https://cdn.buttercms.com/jY33BU1aTba0k5CEIZFg"
    description=""
  />
)
